import { produce } from 'immer';
import cloneDeep from 'lodash/cloneDeep';
import { DEFAULT_AVATAR_PROPERTIES_SET } from '../../types/avatarTypes';
import { uuid } from '../../utils/utils';
import { CANCEL_PENDING_AVATAR_CHANGES, CHANGE_SELF_AVATAR_PART_COLOR, CLEAR_SELF_AVATAR_STATE, INIT_NEW_AVATAR, SET_AVATAR_PART_INDEX, SET_IS_AVATAR_EDITOR_OPEN, SET_PENDING_AVATAR, SET_SELF_AVATAR, UPDATE_AVATAR_FROM_PENDING } from '../actions/selfAvatarActions';
const initialState = {
    isAvatarEditorOpen: false
};
const selfAvatarReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_SELF_AVATAR_STATE: {
                return initialState;
            }
            case INIT_NEW_AVATAR: {
                draft.avatar = {
                    savedAvatar: { type: 'custom', avatar: cloneDeep(DEFAULT_AVATAR_PROPERTIES_SET), uuid: uuid() },
                    pendingAvatar: { type: 'custom', avatar: cloneDeep(DEFAULT_AVATAR_PROPERTIES_SET), uuid: uuid() }
                };
                break;
            }
            case SET_SELF_AVATAR: {
                draft.avatar = {
                    savedAvatar: action.payload,
                    pendingAvatar: action.payload
                };
                break;
            }
            case CHANGE_SELF_AVATAR_PART_COLOR: {
                if (!draft.avatar) {
                    console.warn('Cannot change avatar part color when no self avatar object exists');
                    break;
                }
                if (draft.avatar.pendingAvatar.type !== 'custom') {
                    console.warn(`Cannot change avatar part color for type: ${draft.avatar.pendingAvatar.type}`);
                    break;
                }
                draft.avatar.pendingAvatar.avatar.properties.colors[action.payload.colorType] = action.payload.color;
                break;
            }
            case CANCEL_PENDING_AVATAR_CHANGES: {
                if (!draft.avatar) {
                    console.warn('Cannot cancel avatar editing when no self avatar object exists');
                    break;
                }
                draft.avatar.pendingAvatar = draft.avatar.savedAvatar;
                break;
            }
            case UPDATE_AVATAR_FROM_PENDING: {
                if (!draft.avatar) {
                    console.warn('Cannot update avatar from pending when no self avatar object exists');
                    break;
                }
                draft.avatar.savedAvatar = draft.avatar.pendingAvatar;
                break;
            }
            case SET_AVATAR_PART_INDEX: {
                if (!draft.avatar) {
                    console.warn('Cannot set avatar part index when no self avatar object exists');
                    break;
                }
                if (draft.avatar.pendingAvatar.type !== 'custom') {
                    console.warn(`Cannot change avatar part index for type: ${draft.avatar.pendingAvatar.type}`);
                    break;
                }
                const { partType, index, subType } = action.payload;
                draft.avatar.pendingAvatar.avatar.properties.parts[partType].index = index;
                if (!subType) {
                    delete draft.avatar.pendingAvatar.avatar.properties.parts[partType].subType;
                }
                else {
                    draft.avatar.pendingAvatar.avatar.properties.parts[partType].subType = subType;
                }
                break;
            }
            case SET_IS_AVATAR_EDITOR_OPEN: {
                draft.isAvatarEditorOpen = action.payload;
                break;
            }
            case SET_PENDING_AVATAR: {
                if (!draft.avatar) {
                    console.warn('Cannot set full pending avatar object when no self avatar object exists');
                    break;
                }
                if (draft.avatar.pendingAvatar.type !== 'custom') {
                    console.warn(`Cannot set full pending avatar object for type: ${draft.avatar.pendingAvatar.type}`);
                    break;
                }
                draft.avatar.pendingAvatar.avatar = action.payload;
                break;
            }
            default: {
                return state;
            }
        }
    });
};
export default selfAvatarReducer;
